import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Twitter, Instagram, Youtube, Zap } from 'lucide-react';
import { SubscribeForm } from './components/SubscribeForm';
export function App() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.7,
        ease: [0.16, 1, 0.3, 1]
      }
    }
  };
  return <div className="min-h-screen flex flex-col relative overflow-hidden bg-brand-dark" data-id="element-0">
      {/* Subtle background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[500px] bg-brand-red/10 blur-[120px] rounded-full pointer-events-none" data-id="element-1" />

      {/* Header */}
      <header className="w-full p-6 md:p-8 flex justify-between items-center z-10" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="flex items-center gap-2.5" data-id="element-3">
          <div className="bg-brand-red text-white p-1.5 rounded-lg shadow-lg shadow-brand-red/20" data-id="element-4">
            <Zap className="w-5 h-5 fill-current" data-id="element-5" />
          </div>
          <span className="font-black text-2xl tracking-tight uppercase font-sans" data-id="element-6">
            Super Short
          </span>
        </motion.div>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex flex-col items-center justify-center px-6 z-10 w-full max-w-4xl mx-auto text-center mt-12 md:mt-0" data-id="element-7">
        <motion.div variants={containerVariants} initial="hidden" animate="visible" className="w-full" data-id="element-8">
          {/* Badge */}
          <motion.div variants={itemVariants} className="flex justify-center mb-8" data-id="element-9">
            <div className="inline-flex items-center gap-2.5 px-4 py-2 rounded-full bg-zinc-900/80 border border-zinc-800 backdrop-blur-sm shadow-xl" data-id="element-10">
              <span className="relative flex h-2.5 w-2.5" data-id="element-11">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-brand-red opacity-75" data-id="element-12"></span>
                <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-brand-red" data-id="element-13"></span>
              </span>
              <span className="text-sm font-semibold text-zinc-300 tracking-wide" data-id="element-14">
                जल्द आ रहा है
              </span>
            </div>
          </motion.div>

          {/* Headline */}
          <motion.h1 variants={itemVariants} className="text-5xl md:text-7xl lg:text-8xl font-black leading-[1.1] md:leading-[1.1] tracking-tight mb-6 text-zinc-50" data-id="element-15">
            जनहित की खबरें,
            <br data-id="element-16" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-red to-rose-400" data-id="element-17">
              संक्षेप में।
            </span>
          </motion.h1>

          {/* Subheadline */}
          <motion.p variants={itemVariants} className="text-lg md:text-xl text-zinc-400 max-w-2xl mx-auto mb-12 leading-relaxed font-medium" data-id="element-18">
            शोरगुल से दूर, सिर्फ काम की बात। एक ऐसा न्यूज़ प्लेटफॉर्म जो आपके
            समय की कद्र करता है। सच्ची और सटीक खबरें, सीधे आप तक।
          </motion.p>

          {/* Subscribe Form */}
          <motion.div variants={itemVariants} data-id="element-19">
            <SubscribeForm data-id="element-20" />
          </motion.div>
        </motion.div>
      </main>

      {/* Footer */}
      <footer className="w-full p-6 md:p-8 flex flex-col md:flex-row justify-between items-center gap-6 z-10 text-zinc-500 border-t border-zinc-900/50 mt-12 md:mt-0 bg-brand-dark/50 backdrop-blur-md" data-id="element-21">
        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1,
        duration: 0.5
      }} className="text-sm font-medium" data-id="element-22">
          &copy; {new Date().getFullYear()} Super Short. सर्वाधिकार सुरक्षित।
        </motion.p>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1.1,
        duration: 0.5
      }} className="flex items-center gap-3" data-id="element-23">
          <a href="#" className="hover:text-brand-red hover:bg-zinc-900 transition-all p-2.5 rounded-full" data-id="element-24">
            <Twitter className="w-5 h-5" data-id="element-25" />
            <span className="sr-only" data-id="element-26">Twitter</span>
          </a>
          <a href="#" className="hover:text-brand-red hover:bg-zinc-900 transition-all p-2.5 rounded-full" data-id="element-27">
            <Instagram className="w-5 h-5" data-id="element-28" />
            <span className="sr-only" data-id="element-29">Instagram</span>
          </a>
          <a href="#" className="hover:text-brand-red hover:bg-zinc-900 transition-all p-2.5 rounded-full" data-id="element-30">
            <Youtube className="w-5 h-5" data-id="element-31" />
            <span className="sr-only" data-id="element-32">YouTube</span>
          </a>
        </motion.div>
      </footer>
    </div>;
}